import AcademyLogoShortIcon from './AcademyLogoShortIcon';
export default AcademyLogoShortIcon;
